const  Images={
   car1:"./images/car1.png",
    car2: "./images/car2.png",
    car3: "./images/car3.webp ",
}

export default Images;